import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

const PrimarySmallButton = withStyles(() => ({
    root: {
        color: '#ffffff',
        backgroundColor: '#237fc2',
        '&:hover': {
            backgroundColor: '#65a9db',
        },
        '&:active': {
            backgroundColor: '#1b669d',
        },
        '&:disabled': {
            color: '#ffffff',
            backgroundColor: '#a7cce7',
        },
        borderRadius: 10,
        padding: '9px 10px'
    },
    label: {
        fontSize: 9,
        fontFamily: 'UniviaPro-Bold',
        letterSpacing: 0.36,
        lineHeight: '11px',
        marginTop: 2
    }
}))(Button);

const PrimaryMediumButton = withStyles(() => ({
    root: {
        color: '#ffffff',
        backgroundColor: '#237fc2',
        '&:hover': {
            backgroundColor: '#65a9db',
        },
        '&:active': {
            backgroundColor: '#1b669d',
        },
        '&:disabled': {
            color: '#ffffff',
            backgroundColor: '#a7cce7',
        },
        borderRadius: 10,
        padding: '12px 16px'
    },
    label: {
        fontSize: 11,
        fontFamily: 'UniviaPro-Bold',
        letterSpacing: 0.44,
        lineHeight: '11px',
    }
}))(Button);

const SecondarySmallButton = withStyles(() => ({
    root: {
        color: '#237fc2',
        backgroundColor: '#c1e5fa',
        '&:hover': {
            color: '#ffffff',
            backgroundColor: '#65a9db',
        },
        '&:active': {
            backgroundColor: '#237fc2',
        },
        '&:disabled': {
            color: '#ffffff',
            backgroundColor: '#a7cce7',
        },
        borderRadius: 10,
        padding: '9px 10px'
    },
    label: {
        fontSize: 9,
        fontFamily: 'UniviaPro-Bold',
        letterSpacing: 0.36,
        lineHeight: '11px',
        marginTop: 2
    }
}))(Button);

function CustomizeButton({ label, onClick, large, secondary, ...props }) {
    if (!large) {
        if (secondary) {
            return <SecondarySmallButton {...props} onClick={onClick}>{label}</SecondarySmallButton>
        }
        return (
            <Button size='small' variant='contained' color='primary' {...props} onClick={onClick}>{label}</Button>
        );
    }
    return <Button variant='contained' color='primary' {...props} onClick={onClick}>{label}</Button>
}


CustomizeButton.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
    large: PropTypes.bool,
    secondary: PropTypes.bool,
}

export default CustomizeButton;
